import { render, staticRenderFns } from "./Lister.vue?vue&type=template&id=db277bb4&scoped=true&"
import script from "./Lister.vue?vue&type=script&lang=ts&"
export * from "./Lister.vue?vue&type=script&lang=ts&"
import style0 from "./Lister.vue?vue&type=style&index=0&id=db277bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db277bb4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductTileQuantity: require('/home/vsts/work/1/a/NuxtApp/components/product/TileQuantity.vue').default,BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default})
